/**
 * 登录
 */
import { routerRedux } from 'dva/router'
import controllerUser from 'controller/user';
import getUserRole from 'controller/userAPI';
import { storage } from 'utils';

export default {
  namespace: 'login',
  state: {
    // 用户信息
    loginInfo: {},
    // 验证码
    captcha: '',
    // 提示消息
    message: '',
    userRoleData:[],
    changeUserRole:[],
    loading:false
  },
  effects: {
    * setLoading({ payload }, { call, put, select }) {
      yield put({
        type: 'updateState',
        payload: {
          loading: payload.loading
        },
      });
    },
    * captchaFn({ payload }, { call, put }) {
      const captcha = controllerUser.getApi('captcha');
      yield put({
        type: 'updateState',
        payload: {
          captcha: `${captcha}?source=${payload.source}`
        },
      });
    },
    * searchRole({ payload }, { call, put ,select}) {
      const userRoleData = yield select(state=>state.login.userRoleData)
      let arr = []
      if(payload.searchValue){
        userRoleData.forEach(item => {
          if(item.roleName.indexOf(payload.searchValue) != -1){
            arr.push(item)
          }
        });
      }else{
        arr = JSON.parse(JSON.stringify(userRoleData))
      }
      yield put({
        type: 'updateState',
        payload: {
          changeUserRole: arr
        },
      });
    },
    * loginFn({ payload }, { call, put }) {
      debugger
      const res = yield call(controllerUser.login, payload);
      if (res.code === __SUCCESS__) {
        // 获取业务系统注册信息
        const res2 = yield call(controllerUser.regist, {
          "userName": res.data.loginName
        });


        yield put({
          type: 'updateState',
          payload: {
            loginInfo: res.data,
            registerInfo: res2.data,
            // loading:false
          },
        });



        // 缓存用户登录信息
        storage.set('loginInfo', res.data);
        storage.set('registerInfo', res2.data);
        window.localStorage.setItem('cor-ticket', !!res.data && !!res.data.corTicket ? res.data.corTicket : '')
        window.localStorage.setItem('corTicket', !!res.data && !!res.data.corTicket ? res.data.corTicket : '')

        const userRoleRes = yield call(getUserRole.getUserRole, {
          "userId": res.data.userId
        });
        if(userRoleRes.status && userRoleRes.data){
          let roles = userRoleRes.data.userRoles || []
          yield put({
            type: 'updateState',
            payload: {
              userRoleData: JSON.parse(JSON.stringify(roles)),
              changeUserRole: JSON.parse(JSON.stringify(roles)),
              message:''
            },
          });
        }else{
          yield put({
            type: 'updateState',
            payload: {
              message: userRoleRes.message,
            },
          });
        }
        debugger
        // 登录成功跳转首页 有选择默认角色关闭 无打开
        yield put(routerRedux.push('/home'));
        // 登录成功跳转首页 有选择默认角色关闭 无打开
      } else {
        // 提示错误
        yield put({
          type: 'updateState',
          payload: {
            message: res.message,
            // loading:false
          },
        });
      }
    },
    * logoutFn({ payload }, { call, put }) {
      const response = yield call(controllerUser.logout, payload);
      if (response.code === __SUCCESS__) {
        yield put({
          type: 'updateState',
          payload: {
            loginInfo: {},
          },
        });
        storage.clear('loginInfo');
      }
    },
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    }
  },
};
